import React from 'react';
import { motion } from 'framer-motion';
import { HiOutlineAcademicCap, HiOutlineBookOpen, HiOutlineClipboardList } from 'react-icons/hi';

const CoursesHero = () => {
  return (
    <div className="relative w-full h-[45vh] sm:h-[50vh] md:h-[55vh] lg:h-[60vh] overflow-hidden">
      {/* Background Image with Parallax */}
      <motion.div
        initial={{ scale: 1.2 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5 }}
        className="absolute inset-0"
      >
        <img
          src="/assets/course.png"
          alt="Courses Banner"
          className="w-full h-full object-cover"
        />
      </motion.div>

      {/* Light Gradient Overlay - Gray */}
      <div className="absolute inset-0 bg-gradient-to-r from-gray-200/80 via-gray-100/70 to-gray-200/80" />
      
      {/* Animated Background Elements - Light Gray */}
      <motion.div 
        className="absolute top-20 left-10 text-gray-300/40 hidden lg:block"
        animate={{
          y: [0, -20, 0],
          rotate: [0, 10, -10, 0]
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        <HiOutlineAcademicCap size={80} />
      </motion.div>

      <motion.div 
        className="absolute bottom-20 right-10 text-gray-300/40 hidden lg:block"
        animate={{
          y: [0, 20, 0],
          rotate: [0, -10, 10, 0]
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        <HiOutlineBookOpen size={70} />
      </motion.div>

      <motion.div 
        className="absolute top-40 right-40 text-gray-300/40 hidden lg:block"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.2, 0.3, 0.2]
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        <HiOutlineClipboardList size={60} />
      </motion.div>

      {/* Hero Content - Dark text for contrast */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6">
        <motion.h1 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4 text-gray-800 drop-shadow-md"
        >
          COURSES & ADMISSION
        </motion.h1>
        
        <motion.p 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-sm sm:text-base md:text-lg max-w-3xl px-4 text-gray-700 leading-relaxed"
        >
          Welcome to our Courses & Admission section, designed exclusively for our alumni community! 
          Whether you're looking to enhance your skills, explore new fields, or advance your career, 
          we offer a range of specialized courses tailored for professional growth.
        </motion.p>

        {/* Quick Stats - Light Gray */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="flex items-center space-x-4 mt-6 sm:mt-8 bg-white/60 backdrop-blur-md rounded-full px-4 sm:px-6 py-2 sm:py-3 border border-gray-300/60 shadow-sm"
        >
          <div className="flex items-center space-x-2">
            <HiOutlineAcademicCap className="w-4 h-4 sm:w-5 sm:h-5 text-gray-600" />
            <span className="text-gray-600 text-xs sm:text-sm font-medium">UG Programs</span>
          </div>
          <div className="w-px h-4 bg-gray-300" />
          <div className="flex items-center space-x-2">
            <HiOutlineBookOpen className="w-4 h-4 sm:w-5 sm:h-5 text-gray-600" />
            <span className="text-gray-600 text-xs sm:text-sm font-medium">PG Programs</span>
          </div>
          <div className="w-px h-4 bg-gray-300" />
          <div className="flex items-center space-x-2">
            <HiOutlineClipboardList className="w-4 h-4 sm:w-5 sm:h-5 text-gray-600" />
            <span className="text-gray-600 text-xs sm:text-sm font-medium">Admissions</span>
          </div>
        </motion.div>

        {/* Scroll Indicator - Light Gray */}
        <motion.div 
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <div className="w-6 h-10 border-2 border-gray-400 rounded-full flex justify-center backdrop-blur-sm">
            <div className="w-1 h-2 bg-gray-400 rounded-full mt-2" />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CoursesHero;